import styled from "styled-components"
import { B1, Heading4 } from "../../style/constant"
import { useRecoilValue } from "recoil"
import { langSelector } from "../../state/langState"

const Footer = () => {
  const Text = useRecoilValue(langSelector)
  return(
    <Container>
      <Wrapper>
        <TopArea>
          <UL>
            <Title>Pages</Title>
            <li>Home</li>
            <li>About</li>
          </UL>
          <UL>
            <Title>Business</Title>
            <li>cs@traum.biz</li>
          </UL>
          <UL>
            <Title>TRAUM info Tech</Title>
            <li>{Text.footer.address}</li>
          </UL>
        </TopArea>

        <BottomArea>
          <Logo src={"/imgs/header/mainLogo.png"} alt="traum_logo" />
          <CopyRight>@Traum. All Reserved</CopyRight>
        </BottomArea>
      </Wrapper>
    </Container>
  )
}

export default Footer 

const Container = styled.footer`
  background:#030914;   
  height:480px;
`

const Wrapper = styled.div`
  width:1200px;
  margin: 0 auto;
`

const TopArea = styled.div`
  display: flex;
  margin: 0 0 169.5px 0;
`
const UL = styled.ul`
  margin:81px 119.5px 0 0;
  ${B1};
  li{
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    margin: 0 0 15px 0;
    color:#AAAAAA;
  }
`

const Title = styled.p`
  color:#B7B7B7;
  margin:0 0 25px 0;
`

const BottomArea = styled.div`
  display: flex;
  justify-content: space-between;

`
const Logo = styled.img`
  width:253px;
  height:33px;
`

const CopyRight = styled.p`
  ${Heading4};
  color:#B7B7B7;
`